import React from "react";
import { ColorChip } from "../../../components/Chip";
import { TicketStatus } from "../../../api/services";

export const TicketStatusCell: React.FC<{
  status: TicketStatus;
}> = ({ status }) => {
  const type =
    status === "Open"
      ? "Info"
      : status === "Closed"
      ? "Success"
      : status === "Error"
      ? "Error"
      : undefined;
  return <ColorChip type={type} label={status} />;
};
